<script setup>
import {computed, ref, watch} from 'vue'
import {
    calendlyEmbedConsented,
    calendlyEmbedConsentFailed,
    calendlyEmbedConsentRecording,
    consentToCalendlyEmbed,
} from '../../../../helpers/calendlyEmbedConsent';

const props = defineProps({
    content: {
        type: Object,
        required: true,
    },
});

const url = computed(() => {
    const calendlyUrl = props.content?.text?.trim();
    if (! calendlyUrl) {
        return '';
    }
    return calendlyUrl + '?embed_type=Inline&hide_event_type_details=1&hide_gdpr_banner=1'
});
const loaded = ref(false);

watch(calendlyEmbedConsented, (consented) => {
    if (consented) {
        setTimeout(function(){
            loaded.value = true
        }, 1000)
    }
}, { immediate: true });

</script>

<template>
    <div>
        <div v-if="!calendlyEmbedConsented" class="grid-cols-2 gap-4 md:grid">
            <div class="col-span-1 flex flex-col justify-center">
                <p class="font-medium">
                    <mf-translate domainkey="cookieBanner:nonEssentialCookiesRequired"></mf-translate>
                </p>
                <p class="mt-1 text-sm opacity-75">
                    <mf-translate domainkey="pagebuilderBlock:calendly.placeholder.provider"></mf-translate>
                </p>
                <button-primary
                    :disabled="calendlyEmbedConsentRecording"
                    :state="calendlyEmbedConsentRecording ? 'waiting' : ''"
                    @click="consentToCalendlyEmbed"
                    class="inline-block w-full px-4 py-2 mt-4 overflow-hidden rounded-custom shadow-custom justify-center"
                >
                    <mf-translate domainkey="cookieBanner:consentToNonEssentialCookies"></mf-translate>
                </button-primary>
                <p v-if="calendlyEmbedConsentFailed" class="mt-2 text-xs text-myflowRed" role="alert">
                    <mf-translate domainkey="cookieBanner:saveFailed"></mf-translate>
                </p>
            </div>
            <div class="col-span-1 mt-4 md:mt-0" inert>
                <dummy-blurred-calendar></dummy-blurred-calendar>
            </div>
        </div>
        <template v-else-if="url">
            <mf-spinner-medium v-if="!loaded" class="w-24 h-12"></mf-spinner-medium>
            <iframe
                :src="url"
                width="100%"
                height="100%"
                style="border: 0; height: 700px;"
                title="Select a Date &amp; Time - Calendly"
                class="transition-opacity duration-500"
                :class="! loaded ? 'opacity-0' : 'opacity-100'"
            ></iframe>
        </template>
    </div>
</template>

